import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { selectToastData } from "../../../store/slices/toastSlice";
import { Snackbar } from "kvweb-ui";

export default function MuiToast() {
  const { t } = useTranslation();
  const toastStore = useSelector(selectToastData);
  const [open, setOpen] = useState(false);
  const [offset, setOffset] = useState(0);

  const [toastState, setToastState] = useState<{
    type?: "success" | "warning" | "danger" | "info";
    interpolation: { [key: string]: unknown },
    mess: string;
    sub: string;
  }>({
    interpolation: {},
    type: undefined,
    mess: "",
    sub: "",
  });

  const handleClose = (
    event?: React.SyntheticEvent | Event,
    reason?: string
  ) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };

  const getOffset = () => {
    const fixBottomDom = document.getElementById("fix-bottom-box");
    if (fixBottomDom) {
      return fixBottomDom.offsetHeight || 0;
    }
    return 0;
  };
  useEffect(() => {
    if (toastStore.mess) {
      if (toastStore.offSetBottom !== null) {
        setOffset(toastStore.offSetBottom);
      } else if (window) {
        setOffset(getOffset);
      }
      setOpen(true);
      setToastState(toastStore);
    }
  }, [toastStore]);

  return (
    <div>
      <Snackbar
        sx={{ marginBottom: `${offset}px` }}
        open={open}
        onClose={handleClose}
        autoHideDuration={2000}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        children={t(toastState.mess, toastState.interpolation) || toastState.mess}
        typeAlert={toastState.type}
      />
    </div>
  );
}
